import classNames from 'classnames';
import React from 'react';
import ICONS from './icons';

const styles = require('./Icon.module.scss');

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

export type IconWeight = 'bold' | 'thick';

export type IconColor =
  | 'company' | 'company-light' | 'company-subtle' | 'company-darker'
  | 'talent' | 'talent-light' | 'talent-subtle' | 'talent-darker'
  | 'success' | 'info' | 'warning' | 'error'
  | 'body' | 'caption' | 'disable' | 'placeholder'
  | 'white' | 'black' | 'surface-white' | 'surface-dark'
  | 'ai' | string;

export interface IconProps {
  'aria-hidden'?: boolean | 'true' | 'false';
  'aria-label'?: string;
  className?: string;
  color?: IconColor;
  name: string;
  role?: string;
  size?: IconSize;
  weight?: IconWeight;
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 'md',
  color,
  weight,
  className,
  'aria-hidden': ariaHidden = true,
  'aria-label': ariaLabel,
  role,
}) => {
  const svg = ICONS[name];
  if (!svg) return null;

  const iconClassName = classNames(
    styles.icon,
    styles[`size-${size}`],
    color && styles[`color-${color}`],
    weight && styles[`weight-${weight}`],
    className,
  );

  const resolvedAriaHidden = ariaLabel ? undefined : ariaHidden;

  return (
    <span
      className={iconClassName}
      dangerouslySetInnerHTML={{ __html: svg }}
      aria-hidden={resolvedAriaHidden}
      aria-label={ariaLabel}
      role={ariaLabel ? 'img' : role}
    />
  );
};

export default Icon;
